module.exports = __webpack_public_path__ + "mo/img/mo_logo_wh.6039e65b.svg";